import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
  searchSubscriptionMeta,
  SEARCH_SUBSCRIPTION_PLAN_BILLING_PERIOD,
  SEARCH_SUBSCRIPTION_PLAN,
} from '../../../../../temp/views/onboarding/PhotoSearchCheckout/helpers';
import { formatPriceForDisplay } from '../../../../../../util/format-money';
import Button from '../../../../../../components/global/Button';

const propTypes = {
  searchSubscriptionItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      plan: PropTypes.string.isRequired,
      days: PropTypes.number.isRequired,
      billing_period: PropTypes.string.isRequired,
      price: PropTypes.shape({
        value: PropTypes.number.isRequired,
      }).isRequired,
      trial_days: PropTypes.number,
    }),
  ),
  onPlanSelected: PropTypes.func.isRequired,
};

const PlanSelection = ({ searchSubscriptionItems, onPlanSelected }) => {
  return (
    <div className="shutterbug-plan-wrapper">
      {searchSubscriptionItems.map(plan => {
        if (
          plan.billing_period !==
          SEARCH_SUBSCRIPTION_PLAN_BILLING_PERIOD.MONTHLY
        ) {
          return null;
        }

        const planMeta = searchSubscriptionMeta[plan.plan];
        const isPremium =
          plan.plan === SEARCH_SUBSCRIPTION_PLAN.SHUTTERBUG_PREMIUM;
        const yearlyPlan = searchSubscriptionItems.find(
          subscriptionItem =>
            subscriptionItem.plan === plan.plan &&
            subscriptionItem.billing_period ===
              SEARCH_SUBSCRIPTION_PLAN_BILLING_PERIOD.YEARLY,
        );

        return (
          <div
            key={plan.id}
            className={classNames({
              'shutterbug-plan-container': true,
              'shutterbug-plan-container-premium': isPremium,
            })}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h3 className="shutterbug-plan-title">{planMeta.shortLabel}</h3>
              <div>
                <h4 className="mb-0">
                  ${formatPriceForDisplay(plan.price.value, true)}
                  <span className="text-xs text-black">/month</span>
                </h4>
                <span className="text-xs text-bold">
                  or ${formatPriceForDisplay(yearlyPlan.price.value, true)}/year
                </span>
              </div>
            </div>
            <ul className="view-register-features">
              {planMeta.features.map(feature => {
                return <li key={feature}>{feature}</li>;
              })}
            </ul>
            <div className="mt-auto">
              <Button
                className="view-register-cta"
                btnBlock
                btnSize="lg"
                onClick={() => onPlanSelected(plan)}
              >
                Start {plan.trial_days} days of {planMeta.shortLabel}
              </Button>

              <p className="text-center text-sm mt-2">
                Free for the first {plan.trial_days} days. <br />$
                {formatPriceForDisplay(plan.price.value, true)} / month or $
                {formatPriceForDisplay(yearlyPlan.price.value, true)} / year
                after.
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

PlanSelection.propTypes = propTypes;

export default PlanSelection;
